import { connect } from 'react-redux'
import { change } from 'redux-form'
import { geocodeAddress } from '../../../actions/geocodeActionCreators'
import {
  fetchPositions,
  prefillSelectedPosition
} from '../../../actions/positionActionCreators'

const mapStateToProps = (state) => ({
  busy: state.busy,
  initialValues: {
    address: state.lead.address,
  },
})

const mapDispatchToProps = (dispatch) => ({
  onAddressSelect: (address) => {
    dispatch(geocodeAddress(address))

    // Manually trigger form's CHANGE event
    // TODO This is not very nice
    dispatch(change('addressForm', 'address', address))
  },
  onSubmit: () => {
    dispatch(fetchPositions())
      .then(() => dispatch(prefillSelectedPosition()))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/components/Nav/AddressForm/addressFormContainer.js